angular.module('impactx.greetingcard').controller('ProductGreetingCardCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    'ToastService',
    'ToolbarService',
    '$routeParams',
    'BackService',
    ProductGreetingCardCtrl
]);

function ProductGreetingCardCtrl($scope, dataGen, TranslationService, ToastService, ToolbarService, $routeParams, BackService) {
    var self = this;
    dataGen.getData($scope, {proId: $routeParams.id}, "/greetingcard/productgreetingcard/view").then(function () {
        defineButtons();
    });

    this.save = function () {
        return dataGen.postAsForm({}, {data: $scope.data}, "/greetingcard/productgreetingcard/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    function defineButtons() {
        ToolbarService.setButtons([{
                label: TranslationService.get("save"),
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ]);
    }
}
